import get from 'lodash/get'
import { default as deserialize, formatMeta } from 'app/utils/deserialize'
import { fetch, update } from 'app/utils/data'
import { buildFilters } from './utils'

export default {
  namespaced: true,

  state: {
    list: [],
    item: {
      subscription: {},
      total: {}
    },
    pagination: {}
  },

  getters: {
    currentBraintreeSubscriptions: (state) => state.list,
    currentBraintreeSubscription: (state) => state.item,
    currentPagination: (state) => state.pagination
  },

  mutations: {
    braintreeSubscriptionsFetched(state, { braintreeSubscriptions }) {
      state.list = braintreeSubscriptions
    },

    braintreeSubscriptionFetched(state, { braintreeSubscription }) {
      state.item = braintreeSubscription
    },

    paginationFetched(state, { pagination }) {
      state.pagination = pagination
    }
  },

  actions: {
    async fetchBraintreeSubscriptions({ commit }, { page = 1, filters = {} }) {
      const response = await fetch({
        url: '/api/admin/braintree-subscriptions',
        params: {
          page,
          ...buildFilters(filters)
        }
      })

      const braintreeSubscriptions = await deserialize(response.data)
      const pagination = formatMeta(get(response.data, 'meta', {}))

      commit('braintreeSubscriptionsFetched', { braintreeSubscriptions })
      commit('paginationFetched', { pagination })
    },

    async fetchBraintreeSubscription({ commit }, braintreeSubscriptionId) {
      const response = await fetch({ url: `/api/admin/braintree-subscriptions/${braintreeSubscriptionId}` })
      const braintreeSubscription = await deserialize(response.data)

      commit('braintreeSubscriptionFetched', { braintreeSubscription })
    },

    async updateBraintreeSubscription({ commit, state, dispatch }, changes) {
      const response = await update({
        url: `/api/admin/braintree-subscriptions/${state.item.id}`,
        patch: true,
        type: 'braintreeSubscription',
        changes,
        record: state.item
      })

      const braintreeSubscription = await deserialize(response.data)

      commit('braintreeSubscriptionFetched', { braintreeSubscription })
    }
  }
}
